import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import Form from 'components/molecules/Form'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants';
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import React, { useState } from 'react'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import ObjectLunchOption from 'utils/objects/lunch-option'
import MutateToLunchOption, { MutateToLunchOptionTables } from 'utils/mutate/to-lunch-option'
import FetchCachedBuilding from 'utils/fetch/cached/FetchCachedBuilding'
import VStack from 'components/atoms/stack/VStack'

const BuildingLunch = ({ building }) => {
	
	const _lunchOptions = useSelector( state => {
		return state.data[dataConstants.LUNCH_OPTIONS];
	} )
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	
	// Get the selected lunch options
	const lunchOptions = ObjectLunchOption.getOptions( {
		building: building,
	} );
	
	const onSubmit = ( data, { callback } = {} ) => {
		callback( FormStatus.LOADING )
		
		MutateToLunchOption.mutate( MutateToLunchOptionTables.BUILDING, building.guid, data.lunch_options, {
			callbackSuccess: ( result ) => {
				callback( FormStatus.SUCCESS );
				
				setTimeout( () => {
					return callback(FormStatus.NONE);
				}, 2000 );
				
				FetchCachedBuilding.reload()
			},
			callbackError: ( result ) => {
				callback( FormStatus.ERROR );
			}
		})
	}
	
	// Create the default form values
	const formFields = [
		{
			name: 'lunch_options',
			label: i18n.t( 'management:form.lunch_options.title' ),
			hint: i18n.t( 'management:form.lunch_options.hint' ),
			type: FormFieldsConstants.SELECT_MULTI,
			options: _.map( _lunchOptions, o => {
				return {
					value: o.guid,
					label: o.name
				}
			})
		}
	]
	
	return (
		<VStack>
			<ThemedBlock
				header={ i18n.t('management:form_block.title_default') }
				shadow
				mediumPadding>
				
				<Form
					key={ HelperString.hash( 'form', formKey ) }
					values={{
						lunch_options: _.map( lunchOptions, o => {
							return o.guid;
						} )
					}}
					fields={ formFields }
					onSubmit={ onSubmit }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDINGS ) }
				/>
			</ThemedBlock>
		</VStack>
	);
}

export default BuildingLunch
